import expose from './dev-globals';

const urlSearch = new URLSearchParams(window.location.search);

let devMode = __DEV__;

if (urlSearch.get('forcedevmode')) {
    devMode = true;
}

if (urlSearch.get('forceprodmode')) {
    devMode = false;
}

const handlers = new Map();

const isDevMode = () => devMode;
const setDevMode = (value) => {
    devMode = !!value;
    handlers.forEach((v, handler) => {
        handler(devMode);
    });
};
const onChangeDevMode = (handler, immediate = true) => {
    handlers.set(handler, handler);
    if (immediate) {
        handler(devMode);
    }
};

const offChangeDevMode = (handler) => {
    handlers.delete(handler);
};

expose('setDevMode', setDevMode);
expose('isDevMode', isDevMode);

export { setDevMode, isDevMode, onChangeDevMode, offChangeDevMode };
